import React from "react";
import { managementPlan } from "../lib/iris";
import { Sparkles, Droplet, Activity, HeartPulse } from "lucide-react";

function Section({ icon, title, children, testId }) {
  return (
    <div className="card-soft p-6" data-testid={testId}>
      <div className="flex items-center gap-2 text-primary">
        <span className="w-8 h-8 rounded-full bg-primary/10 flex items-center justify-center">
          {icon}
        </span>
        <h4 className="font-display text-base">{title}</h4>
      </div>
      <div className="mt-4 text-sm text-foreground/85 leading-relaxed space-y-2">{children}</div>
    </div>
  );
}

function BulletList({ items }) {
  return (
    <ul className="space-y-2">
      {items.map((t, i) => (
        <li key={i} className="flex gap-2">
          <span className="mt-2 w-1.5 h-1.5 rounded-full bg-primary flex-shrink-0" />
          <span>{t}</span>
        </li>
      ))}
    </ul>
  );
}

export default function ManagementPlan({ iris }) {
  const plan = managementPlan(iris);
  if (!plan) return null;

  return (
    <div className="space-y-6" data-testid="management-plan">
      <div>
        <h3 className="font-display text-2xl">Management strategies</h3>
        <p className="text-sm text-muted-foreground mt-1">
          Based on the IRIS 2023 CKD guidelines. Discuss any changes with your veterinarian.
        </p>
      </div>

      <div className="grid md:grid-cols-2 gap-6">
        <Section icon={<Sparkles size={16} />} title={`Stage ${iris.stage} priorities`} testId="plan-stage">
          <BulletList items={plan.perStage} />
        </Section>
        <Section icon={<HeartPulse size={16} />} title="General care" testId="plan-general">
          <BulletList items={plan.common} />
        </Section>
        <Section icon={<Droplet size={16} />} title="Proteinuria (UPC)" testId="plan-proteinuria">
          <p>{plan.proteinuria}</p>
        </Section>
        <Section icon={<Activity size={16} />} title="Blood pressure" testId="plan-bp">
          <p>{plan.bp}</p>
        </Section>
      </div>
    </div>
  );
}
